import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";
import Section13 from "./Section13";
import Section14 from "./Section14";
import Section15 from "./Section15";
import SectionDevOps from "./SectionDevops";

export default function Shopify_Texas() {
  return (
    <div className="Shopify pt-[160px] sm:pt-0">
      <Helmet>
        <title> Shopify Design and Development Company in Texas | Mean3</title>
        <meta
          name="description"
          content=" Looking for reliable Shopify development services in Texas? Mean3 offers expert Shopify development, scalable stores, and custom designs."
        />
      </Helmet>

      <Section1 />
     
      <Section12 />
       <Section15 />
      <Section2 />
      <Section4 />
      <Section3 />
      <Section5 />
      <Section13 />
      <Section6 />
      <Section14 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
      <Section11 />
    </div>
  );
}
